import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import editIcon from '../../../..//Components/icons/edit-icon.svg'
import classes from './EditableCell.module.css'

const EditableCell = ({ value, onSave }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [currentValue, setCurrentValue] = useState(value)
  const textareaRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = event => {
      if (textareaRef.current && !textareaRef.current.contains(event.target)) {
        finishEditing()
      }
    }

    if (isEditing) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isEditing])

  const finishEditing = () => {
    setIsEditing(false)
    if (currentValue !== value) {
      onSave(currentValue)
    }
  }

  useEffect(() => {
    setCurrentValue(value)
  }, [value])

  return (
    <td
      onDoubleClick={() => setIsEditing(true)}
      className={`${classes.cell} ${isEditing ? classes.editing : ''}`}
    >
      {!isEditing && (
        <img
          id="edit-icon"
          src={editIcon}
          className={classes.editIcon}
          alt="edit-icon"
        />
      )}
      {!isEditing && (
        <div className={classes.tooltip}>Double click to edit</div>
      )}
      {isEditing ? (
        <>
          <div className={`${classes.tooltip} ${classes.tooltipEditing}`}>
            Press enter to save
          </div>
          <textarea
            ref={textareaRef}
            value={currentValue}
            onChange={e => setCurrentValue(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault()
                finishEditing()
              }
            }}
            autoFocus
            rows={3}
            className={classes.textArea}
          />
        </>
      ) : (
        currentValue || '-'
      )}
    </td>
  )
}

EditableCell.propTypes = {
  value: PropTypes.string,
  onSave: PropTypes.func.isRequired,
}

export default EditableCell
